import React, {Component, Fragment} from 'react';
import {Redirect} from "react-router";
import {withTranslation} from "react-i18next";
import Loading from "./Parts/Loading";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import {toast} from "react-toastify";
import DidNotSignBy1Ct from "../ErrorPages/DidNotSignBy1Ct";
import * as qs from 'query-string';

class WaitingConsent extends Component {
    constructor(props) {
        super(props);

        const getParams = qs.parse(location.search, {ignoreQueryPrefix: true});

        this.state = {
            redirectToNextStep: false,
            showSpouseSuccess: false,
            getParams: getParams,
        };
        this.getApplData = this.getApplData.bind(this);
        this.checkConsent = this.checkConsent.bind(this);
        this.getApplData();
    }

    getApplData() {
        axios.get('/api/process/' + this.props.application_token + '/info', {params: {step: 'consent'}})
            .then(
                data => {
                    if (data.data.status === 'success') {
                        this.setState({ trackData: {
                                loan_amount: data.data.data.pref?.amount_total ?? null,
                                loan_period: data.data.data.pref?.term ?? null,
                                product_code: data.data.data?.appl_product ?? null,
                            }
                        });
                    }
                    this.checkConsent();
                }
            );
    }

    checkConsent() {
        axios.get('/api/process/' + this.props.application_token + '/check_consent', {params: {client_type: this.state.getParams.client_type}})
            .then(
                data => {
                    if (data.data.data.has_consent) {
                        if (this.state.getParams.client_type === 'P') {
                            this.setState({redirectToNextStep: true});
                        } else if (this.state.getParams.client_type === 'S') {
                            this.setState({showSpouseSuccess: true});
                        }

                        gtm.sendEvent('auth', {
                            auth_method: 'esign',
                            status: 'OK',
                            auth_purpose: 'consent',
                        });
                        //new version
                        gtm.sendEvent('base', {
                            event: 'loan_application_customer_data_sigining.completed',
                            products: this.state.trackData
                        }, 2);
                    } else {
                        gtm.sendEvent('auth', {
                            auth_method: 'esign',
                            status: 'Fail',
                            auth_purpose: 'consent',
                        });
                        //new version
                        gtm.sendEvent('fail', {
                            event: 'loan_application_customer_data_sigining.completed',
                            products: this.state.trackData
                        }, 2);

                        setTimeout(this.checkConsent, 1000);
                    }

                },
                error => {
                    toast.error(error.response.data.message);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {
        if (this.props.suggestion && this.state.redirectToNextStep) {
            return <Redirect push={true} to={this.props.suggestion.process_step_urls.choose_terms}/>
        }

        return (
            <div>
                {!this.state.showSpouseSuccess &&
                <Fragment>
                    {this.props.should_repeat ?
                        <DidNotSignBy1Ct url={'/' + this.props.application_token + '/process/' + (this.state.getParams.client_type === 'P' ? 'consent' : 'consent_sec')}/>
                        :
                        <div>
                            <Header title={this.props.t('step.proposal')}/>

                            <div className="section window-layout">
                                <div className="container frame">
                                    <SubHeader/>
                                    <Loading msg={this.props.t('forms.waiting_bank_response')}/>
                                </div>
                            </div>
                        </div>
                    }
                </Fragment>
                }

                {this.state.showSpouseSuccess && <Fragment>
                    <Header title={this.props.t('step.proposal')}/>
                    <div className="section window-layout">
                        <div className="container frame">
                            <div className="container py-5">
                                <div className="col-12 d-flex justify-content-center">
                                    <span className="success-icon"><i className="icons icon-check"></i></span>
                                </div>
                                <div className="col-12 mt-2 text-center">
                                    <p>{this.props.t('forms.document_signed_successfully_msg')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>}
            </div>
        )
    }
}

export default withTranslation()(WaitingConsent);
